module.exports = [{"type":"title","text":"2024-10-24"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual USD-M WebSocket Service: Added 'VST' service."},{"type":"html","text":"Added new isolated margin change history interface：/openApi/swap/v1/positionMargin/history"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-10-24.json
// module id = SHTI
// module chunks = 3